import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'
import { connect } from "react-redux";
import ViewTaskHistory from './SubComponentsSwTeamTask/ViewTaskHistory';
import CreateNewTask from './SubComponentsSwTeamTask/CreateNewTask';
import CustomModal from '../../../../Components/Modals/CustomModal';
import AddHistoryService from '../../../../../Service/OPSServices/SWInternalServices/AddHistoryService';
import GridPagination from '../../../../Components/Pagination/GridPagination';
import AllUsersTaskData from './SubComponentsSwTeamTask/AllUsersTaskData';
import fetchAllTasksUserTasksService from '../../../../../Service/OPSServices/SWInternalServices/fetchAllTasksUserTasksService';
import MyTaskDataUi from './SubComponentsSwTeamTask/MyTaskDataUi';
import fetchArchivedTasksService from '../../../../../Service/OPSServices/SWInternalServices/fetchArchivedTasksService';
import ArchivedTaskData from './SubComponentsSwTeamTask/ArchivedTaskData';
import BulkArchiveTaskService from '../../../../../Service/OPSServices/SWInternalServices/BulkArchiveTaskService';
import PCArchiveIcon from '../../../../../designUtils/Storeoverview/PartnerLogs/PCArchiveIcon.svg'


function SWTeamTask(props) {
  const [openTaskTitle, setOpenTaskTitle] = useState(false)
  const [taskName, setTaskName] = useState();
  const [viewTaskPopup, setViewTaskPopup] = useState(false)
  const [taskData, setTaskData] = useState()
  const [createTaskPopup, setCreateTaskPopup] = useState(false)
  const [statusFilter, setStatusFilter] = useState('All')
  const [allStatusFilter, setAllStatusFilter] = useState('All')
  const [assignedLoading, setAssingedLoading] = useState(false)
  const [seletctedCurrentPage,setSeletctedCurrentPage] = useState(3)
  const [seletctedCurrentPg,setSeletctedCurrentPg] = useState(0)
  const [seletctedAllCurrentPg,setSeletctedAllCurrentPg] = useState(0)
  const [assignedToFilter,setAssignedToFilter]=useState()
  const [createdByFilter,setCreatedByFilter]=useState()
  const [todaysTaskFilter,setTodaysTaskFilter]=useState()
  const [allUsersTasks,setAllUsersTasks]=useState()
  const [uiCompentents,setUiCompentents]=useState(false)
  const [allSearchInput,setAllSearchInput]=useState('')
  const [signedOffByFilter,setSignedOffByFilter]=useState()
  const [archivedTasks,setArchivedTasks]=useState()
  const [archivedStatusFilter, setArchivedStatusFilter] = useState('All')
  const [archivedUiCompentents,setArchivedUiCompentents]=useState(false)
  const [seletctedArchivedCurrentPg,setSeletctedArchivedCurrentPg] = useState(0)
  const [archivedSearchInput,setArchivedSearchInput]=useState('')
  const [archiveFlag, setArchiveFlag] = useState(false)
  const [LoggedUserRole,setloggedUserRole] = useState()
  const [selectTaskId, setSelectTaskId] = useState([])
  const [searchInput,setSearchInput]=useState(props.notificationsDetails.searchparams?props.notificationsDetails.searchparams:"")
  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value)
    setSeletctedCurrentPg(0)
  }

  useEffect(() => {

    let data = {
      intId: props.store && props.store.integerID
        ? props.store.integerID
        : 0
    }
  
    // ---------- All Tasks ----------
    if (seletctedCurrentPage === 5) {
  
      props.setloading(true)
  
      fetchAllTasksUserTasksService(props.token, data).then((res) => {
  
        if (res) {
          setAllUsersTasks(res.tasklist)
          setloggedUserRole(res.loggedUserRole)
        }
  
        props.setloading(false)
  
      })
    }
  
    // ---------- Archived Tasks ----------
    else if (seletctedCurrentPage === 7) {
  
      props.setloading(true)
  
      fetchArchivedTasksService(props.token, data).then((res) => {
  
        if (res) {
          setArchivedTasks(res.tasklist)
        }
  
        props.setloading(false)
  
      })
    }
  
  }, [props.store, seletctedCurrentPage])

  const handleAllUserSearchInputChange = (e) => {
    setAllSearchInput(e.target.value)
    setSeletctedAllCurrentPg(0)
  }
  const handleArchivedSearchInputChange = (e) => {
    setArchivedSearchInput(e.target.value)
    setSeletctedArchivedCurrentPg(0)
  }
  const handleBackFunction = (value) => {
    setCreatedByFilter(null) 
    setAssignedToFilter(null)
    setUiCompentents(false)
    setArchivedUiCompentents(false)
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    setAllSearchInput('')
    setArchivedSearchInput('')
    setSeletctedCurrentPage(value)
    setTodaysTaskFilter(null)
    setSignedOffByFilter(null)
    setSeletctedCurrentPg(0)
  }
  const handleAllUserTask=(value)=>{
    setUiCompentents(true)
    setArchivedUiCompentents(false)
    setStatusFilter('All')
    setSearchInput('')
    setArchivedSearchInput('')
    setAssignedToFilter(null);  // Set filter when clicking "Assigned To"
    setCreatedByFilter(null) 
    setSignedOffByFilter(null)
    setTodaysTaskFilter(null)
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    setSeletctedCurrentPage(5)
    setSeletctedAllCurrentPg(0)
    props.setloading(true)
  }

  const handleArchivedTask=(value)=>{
    setUiCompentents(false)
    setArchivedUiCompentents(true)
    setStatusFilter('All')
    setSearchInput('')
    setAllSearchInput('')
    setAssignedToFilter(null);  // Set filter when clicking "Assigned To"
    setCreatedByFilter(null) 
    setSignedOffByFilter(null)
    setTodaysTaskFilter(null)
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    props.setloading(true)
    setSeletctedCurrentPage(7)
    setSeletctedArchivedCurrentPg(0)
  
  }

  const handleAssignedToTaskList = ( page ,tasks, loggedUserId) => {
    setSeletctedCurrentPage(page)
    setAssignedToFilter(loggedUserId);  // Set filter when clicking "Assigned To"
    setCreatedByFilter(null) 
    setSignedOffByFilter(null)
    setUiCompentents(false)
    setArchivedUiCompentents(false)
    setTodaysTaskFilter(null)
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    setAllSearchInput('')
    setArchivedSearchInput('')
    setSeletctedCurrentPg(0)
  };

  const handleCreatedByTaskList = (page ,tasks, loggedUserId) => {
    setSeletctedCurrentPage(page)
    setCreatedByFilter(loggedUserId); 
    setUiCompentents(false)
    setArchivedUiCompentents(false)
    setAllSearchInput('')
    setArchivedSearchInput('')
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    setAssignedToFilter(null)
    setTodaysTaskFilter(null)
    setSignedOffByFilter(null)
    setSeletctedCurrentPg(0)
  };
  const handleTodaysTaskList = ( page ,tasks, loggedUserId) => {
    setUiCompentents(false)
    setArchivedUiCompentents(false)
    console.log(loggedUserId)
    setAllSearchInput('')
    setArchivedSearchInput('')
    setSignedOffByFilter(null)
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    setSeletctedCurrentPage(page)
    setTodaysTaskFilter(loggedUserId);  // Set filter when clicking "Assigned To"
    setCreatedByFilter(null) 
    setAssignedToFilter(null)
    setSeletctedCurrentPg(0)
  };
  const handleSignedOffByTaskList = ( page ,tasks, loggedUserId) => {
    setSeletctedCurrentPage(page)
    setSignedOffByFilter(loggedUserId)
    setAssignedToFilter(null);  // Set filter when clicking "Assigned To"
    setCreatedByFilter(null) 
    setAllSearchInput('')
    setArchivedSearchInput('')
    setAllStatusFilter('All')
    setArchivedStatusFilter('All')
    setUiCompentents(false)
    setArchivedUiCompentents(false)
    setTodaysTaskFilter(null)
    setSeletctedCurrentPg(0)
  };

  const filteredTasks = props.taskList &&props.taskList.filter((task) => {
    const matchesStatus = statusFilter === "All" || task.status === statusFilter;
    const matchesSearch = (task.taskTitle|| '').toLowerCase().includes(searchInput.toLowerCase());
    const priority = (task.priority || '').toLowerCase().includes(searchInput.toLowerCase());
    const assignedToMatch = (task.assignedName||'').toLowerCase().includes(searchInput.toLowerCase());
    const SWTeamTaskIdMatch = (task.SWTeamTaskId || '').toString().includes(searchInput.toLowerCase());
    const statusMatch = (task.status||'').toLowerCase().includes(searchInput.toLowerCase());
    const reference = (task.reference||'').toLowerCase().includes(searchInput.toLowerCase());
    const verifiedByName = (task.verifiedName||'').toLowerCase().includes(searchInput.toLowerCase());
    const matchesStore =
  !props.store ||
  !props.store.integerID ||
  Number(task.IntegerId) === Number(props.store.integerID);

    
    // Filter based on "Assigned To" and "Created By"
    const matchesAssignedToFilter = assignedToFilter ? task.assignedTo === assignedToFilter : true;
    const matchesCreatedByFilter = createdByFilter ? task.createdById === createdByFilter : true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // Set the time to midnight (00:00:00)

    //  Optimized logic to match today's task filter
    const taskDate = new Date(task.plannedStartDate);
    taskDate.setHours(0, 0, 0, 0); // Only need to set the time of task once

    // const matchesTodaysTaskFilter = todaysTaskFilter ? taskDate.getTime() === today.getTime() : true;
    // const matchesTodaysTaskFilter = todaysTaskFilter ? ['New','In Progress', 'Overdue'].includes(task.status) && task.plannedStartDate<= today : true;
    const matchesTodaysTaskFilter = todaysTaskFilter
    ? ['New', 'In Progress', 'Overdue'].includes(task.status) && taskDate.getTime() <= today.getTime(): true;
    const matchesSignedOffByFilter = signedOffByFilter ? task.verifiedBy=== signedOffByFilter : true;
    return (
      matchesStore && matchesStatus &&
      (matchesSearch || statusMatch || assignedToMatch || SWTeamTaskIdMatch ||priority||verifiedByName||reference) &&
      matchesAssignedToFilter && matchesTodaysTaskFilter&&
      matchesCreatedByFilter && matchesSignedOffByFilter
    );
  });
  const filteredAllUserTasks = allUsersTasks &&allUsersTasks.filter((task) => {
    const matchesStatus = allStatusFilter === "All" || task.status === allStatusFilter;
    const matchesSearch = (task.taskTitle|| '').toLowerCase().includes(allSearchInput.toLowerCase());
    const priority = (task.priority || '').toLowerCase().includes(allSearchInput.toLowerCase());
    const assignedToMatch = (task.assignedName||'').toLowerCase().includes(allSearchInput.toLowerCase());
    const SWTeamTaskIdMatch = (task.SWTeamTaskId || '').toString().includes(allSearchInput.toLowerCase());
    const statusMatch = (task.status||'').toLowerCase().includes(allSearchInput.toLowerCase());
    const reference = (task.reference||'').toLowerCase().includes(allSearchInput.toLowerCase());
    const verifiedByName = (task.verifiedName||'').toLowerCase().includes(allSearchInput.toLowerCase());

    
    // Filter based on "Assigned To" and "Created By"
    const matchesAssignedToFilter = assignedToFilter ? task.assignedTo === assignedToFilter : true;
    const matchesCreatedByFilter = createdByFilter ? task.createdById === createdByFilter : true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // Set the time to midnight (00:00:00)

    //  Optimized logic to match today's task filter
    const taskDate = new Date(task.plannedStartDate);
    taskDate.setHours(0, 0, 0, 0); // Only need to set the time of task once

    // const matchesTodaysTaskFilter = todaysTaskFilter ? taskDate.getTime() === today.getTime() : true;
    // const matchesTodaysTaskFilter = todaysTaskFilter ? ['New','In Progress', 'Overdue'].includes(task.status) && task.plannedStartDate<= today : true;
    const matchesTodaysTaskFilter = todaysTaskFilter
    ? ['New', 'In Progress', 'Overdue'].includes(task.status) && taskDate.getTime() <= today.getTime(): true;
    const matchesSignedOffByFilter = signedOffByFilter ? task.verifiedBy=== signedOffByFilter : true;
    return (
      matchesStatus &&
      (matchesSearch || statusMatch || assignedToMatch || SWTeamTaskIdMatch ||priority||verifiedByName||reference) &&
      matchesAssignedToFilter && matchesTodaysTaskFilter&&
      matchesCreatedByFilter && matchesSignedOffByFilter
      // ||reference||verifiedBy
    );
  });
  const filteredArchivedTasks = archivedTasks &&archivedTasks.filter((task) => {
    const matchesStatus = archivedStatusFilter === "All" || task.status === archivedStatusFilter;
    const matchesSearch = (task.taskTitle|| '').toLowerCase().includes(archivedSearchInput.toLowerCase());
    const priority = (task.priority || '').toLowerCase().includes(archivedSearchInput.toLowerCase());
    const assignedToMatch = (task.assignedName||'').toLowerCase().includes(archivedSearchInput.toLowerCase());
    const SWTeamTaskIdMatch = (task.SWTeamTaskId || '').toString().includes(archivedSearchInput.toLowerCase());
    const statusMatch = (task.status||'').toLowerCase().includes(archivedSearchInput.toLowerCase());
    const reference = (task.reference||'').toLowerCase().includes(archivedSearchInput.toLowerCase());
    const verifiedByName = (task.verifiedName||'').toLowerCase().includes(archivedSearchInput.toLowerCase());
    
    // Filter based on "Assigned To" and "Created By"
    const matchesAssignedToFilter = assignedToFilter ? task.assignedTo === assignedToFilter : true;
    const matchesCreatedByFilter = createdByFilter ? task.createdById === createdByFilter : true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // Set the time to midnight (00:00:00)

    //  Optimized logic to match today's task filter
    const taskDate = new Date(task.plannedStartDate);
    taskDate.setHours(0, 0, 0, 0); // Only need to set the time of task once

    const matchesTodaysTaskFilter = todaysTaskFilter
    ? ['New', 'In Progress', 'Overdue'].includes(task.status) && taskDate.getTime() <= today.getTime(): true;
    const matchesSignedOffByFilter = signedOffByFilter ? task.verifiedBy=== signedOffByFilter : true;
    return (
      matchesStatus &&
      (matchesSearch || statusMatch || assignedToMatch || SWTeamTaskIdMatch ||priority||verifiedByName||reference) &&
      matchesAssignedToFilter && matchesTodaysTaskFilter&&
      matchesCreatedByFilter && matchesSignedOffByFilter
      // ||reference||verifiedBy
    );
  });

  const handleCloseCreateTaskPopup = (tasklist) => {
    props.setTaskList(tasklist);
    setCreateTaskPopup(false)
    setViewTaskPopup(false)
  }
  const handleSubmitHistory = (e, task, flag) => {

    const formData = new FormData();
    // formData.append('intId',props.store.integerID?props.store.integerID:0,)
    formData.append('intId', props.store && props.store.integerID ? props.store.integerID : 0)

    if (flag == 'assignedTo') {
      formData.append("assignedTo", e.target.value);
      formData.append("note", 'assignedTo');
    }
    else {
      formData.append("assignedTo", task.assignedTo);
    }
    if (flag == 'status') {
      formData.append("status", e.target.value);
      formData.append("note", 'status');
    }
    else {
      formData.append("status", task.status);
    }
    formData.append("taskId", task.SWTeamTaskId);
    formData.append("flag", 1);

    console.log(formData);
    AddHistoryService(props.token, formData).then((responce) => {
      if (responce) {
        console.log(formData)
        console.log(responce)
        props.setTaskList(responce.tasklist)
        props.setTeamMemberList(responce.teamMembers)
        // handleCreatedByTaskList(responce.tasklist, responce.loggedUserId)
        // handleAssignedToTaskList(responce.tasklist, responce.loggedUserId)
      }
      setAssingedLoading(false)
    })
  }
  const pageSize = 15;  

  const totalRecords = filteredTasks &&filteredTasks.length;
  const startIndex = seletctedCurrentPg * pageSize;
  const endIndex = startIndex + pageSize;
  const tasksToDisplay =filteredTasks && filteredTasks.slice(startIndex, endIndex);
  
  const alltotalRecords = filteredAllUserTasks ?filteredAllUserTasks.length:0;
  const allstartIndex = seletctedAllCurrentPg * pageSize;
  const allendIndex = allstartIndex + pageSize;
  const alltasksToDisplay =filteredAllUserTasks && filteredAllUserTasks.slice(allstartIndex, allendIndex);

  
  const handlePageChange = (pageSize) => {
    setSeletctedCurrentPg(pageSize.currentPage); // Update the page when the user clicks on pagination
  };
  const handleAllUserPageChange = (pageSize) => {
    setSeletctedAllCurrentPg(pageSize.currentPage); // Update the page when the user clicks on pagination
  };

  // ---for Archived Page--------
  const archivedtotalRecords = filteredArchivedTasks ?filteredArchivedTasks.length:0;
  const archivedstartIndex = seletctedArchivedCurrentPg * pageSize;
  const archivedendIndex = archivedstartIndex + pageSize;
  const archivedtasksToDisplay =filteredArchivedTasks && filteredArchivedTasks.slice(archivedstartIndex, archivedendIndex);

  const handleArchivedPageChange = (pageSize) => {
    setSeletctedArchivedCurrentPg(pageSize.currentPage); // Update the page when the user clicks on pagination
  };

  const updateArchivedTasks = () => {
    setArchiveFlag(true)
    let data = {
      id: selectTaskId
    }
    BulkArchiveTaskService(props.token, data).then((res) => {
      if (res) {
        console.log(res.tasklist);
        props.setTaskList(res.tasklist);
        setArchiveFlag(false)
        setSelectTaskId([])
      }
    })
  }

  const assignedToDropdownList =
  props.accessLevel === 0
    ? props.teamMemberList
    : props.agencyMemberList;
  return (
    <>
   
      <Card className="card-min-height-workflows mt-3 p-3 card-of-problemarea">
        <Row>
        <Col md={12} className='mt-2'>
        <div className='d-flex'>
       
          <h6
          className={`mr-3 ${seletctedCurrentPage === 3?'selected-my-tasks':'not-seletcted-tasks'}`}
          onClick={() => handleBackFunction(3)}>
           <b> My Tasks</b>
         
        </h6>
          <h6
            className={seletctedCurrentPage === 2?'selected-my-tasks':'not-seletcted-tasks'}
            onClick={() => handleCreatedByTaskList(2,props.taskList,props.loggedUserId)}>
           <b> Created By Me</b>
          </h6>
          <h6
            className={` ml-3 ${seletctedCurrentPage === 1?'selected-my-tasks ':'not-seletcted-tasks'}`}
            onClick={() => handleAssignedToTaskList(1,props.taskList,props.loggedUserId)}>
            <b>Assigned To Me</b>
          </h6>
          <h6
            className={` ml-3 ${seletctedCurrentPage === 4?'selected-my-tasks ':'not-seletcted-tasks'}`}
            onClick={() => handleTodaysTaskList(4,props.taskList,props.loggedUserId)}>
            <b>Active Tasks</b>
          </h6>
          <h6
            className={` ml-3 ${seletctedCurrentPage === 6?'selected-my-tasks ':'not-seletcted-tasks'}`}
            onClick={() => handleSignedOffByTaskList(6,props.taskList,props.loggedUserId)}>
            <b>Sign Off</b>
          </h6>
          <h6
            className={` ml-3 ${seletctedCurrentPage === 5?'selected-my-tasks ':'not-seletcted-tasks'}`}
            onClick={() => handleAllUserTask(5)}>
            <b>All Tasks</b>
          </h6>
          <h6
            className={` ml-3 ${seletctedCurrentPage === 7?'selected-my-tasks ':'not-seletcted-tasks'}`}
            onClick={() => handleArchivedTask(7)}>
            <b>Archived</b>
          </h6>
          </div>
          {
           props.notificationsDetails.action &&
          <Card className="notification-card p-3  card-of-problemarea">
            <Row>
              <Col md={10}>
              <strong>{props.notificationsDetails.details}</strong>
                </Col>
                <Col md={2} className="text-end">
                <Button 
                        close
                          onClick={()=> props.setNotificationsDetails({
                            tabs: 3,
                            details:'',
                            action:false,
                            searchparams:''
                    
                          })} 
                className="close-button" 
                />
            </Col>
            </Row>
          </Card>}
        </Col>
        <Row className='p-3 '>
          <Col md={12}>
          <Row>
          <Col md={8} className="d-flex">
          {uiCompentents===true?(  // for All Tasks Tab
           <>
           <Input type='text'
           className='w-25 '
           value={allSearchInput}
           placeholder='Search Text'
           onChange={(e) => handleAllUserSearchInputChange(e)}
         />
         <select
      className='form-control w-25 ml-5'
      value={assignedToFilter || ""}
      onChange={(e) => {
        setAssignedToFilter(
          e.target.value ? Number(e.target.value) : null
        );
        setSeletctedAllCurrentPg(0);
      }}
    >
     <option value="">-- Assigned To --</option>

        {assignedToDropdownList && assignedToDropdownList.map((member) => (
          <option
            key={props.accessLevel === 0 ? member.employeeId : member.id}
            value={props.accessLevel === 0 ? member.employeeId : member.id}
          >
            {props.accessLevel === 0 ? member.employeeName : member.name}
          </option>
        ))}
    </select>
    </>):archivedUiCompentents===true?   // for Archived Tasks Tab
         (<Input type='text'
         className='w-25 '
         value={archivedSearchInput}
         placeholder='Search Text'
         onChange={(e) => handleArchivedSearchInputChange(e)}
       />):(                               // for My Tasks Tab 
            <Input type='text'
              className='w-25 '
              value={searchInput}
              placeholder='Search Text'
              onChange={(e) => handleSearchInputChange(e)}
            />)
           }

            </Col>
            <Col md={4} className={`d-flex justify-content-end pagination-item`}>
            {uiCompentents===true? // for All Tasks Tab
              (<GridPagination                 
              pageSize={pageSize}
              totalRecords={alltotalRecords}
              currentPageProp={seletctedAllCurrentPg}
              onPageChange={handleAllUserPageChange}
            />):archivedUiCompentents===true? // for Archived Tasks Tab
            (<GridPagination                 
            pageSize={pageSize}
            totalRecords={archivedtotalRecords}
            currentPageProp={seletctedArchivedCurrentPg}
            onPageChange={handleArchivedPageChange}
          />):(
            <GridPagination             // for My Tasks Tab    
            pageSize={pageSize}
            totalRecords={totalRecords}
            currentPageProp={seletctedCurrentPg}
            onPageChange={handlePageChange}
          />)
          }
             </Col>
            </Row>
            {uiCompentents===true?(         // for All Tasks Tab
             <>
             <label className='mr-3 mt-2'>
               <input type='radio'
                 name='status'
                 checked={allStatusFilter === "All"}
                 value={allStatusFilter}
                 //  checked={status.status}
                 onChange={() => {setAllStatusFilter('All');handleAllUserPageChange({ currentPage: 0 })}} />
               &nbsp;
               <b>All</b>
             </label>
             {props.taskStatus && props.taskStatus.map((status) => (
               <label className='mr-3'>
                 <input type='radio'
                   name='status'
                   checked={allStatusFilter === status.status}
                   value={status.status}
                   //  checked={status.status}
                   onChange={() => {setAllStatusFilter(status.status);handleAllUserPageChange({ currentPage: 0 })}} />
                 &nbsp;
                 <b>{status.status}</b>
               </label>
             ))}
             </>):archivedUiCompentents===true?(      // for Archived Tasks Tab
             <>
             <label className='mr-3 mt-2'>
               
               </label>
             
             </>):(          // for My Tasks Tab
            <>
            <div className="d-flex align-items-center flex-wrap justify-content-between">
             <div className="d-flex align-items-center flex-wrap">
            <label className='mr-3 mt-2'>
              <input type='radio'
                name='status'
                checked={statusFilter === "All"}
                value={statusFilter}
                //  checked={status.status}
                onChange={() => {setStatusFilter('All');handlePageChange({ currentPage: 0 })}} />
              &nbsp;
              <b>All</b>
            </label>
            {props.taskStatus && props.taskStatus.map((status) => (
              <label className='mr-3 mt-2'>
                <input type='radio'
                  name='status'
                  checked={statusFilter === status.status}
                  value={status.status}
                  //  checked={status.status}
                  onChange={() => {setStatusFilter(status.status);handlePageChange({ currentPage: 0 })}} />
                &nbsp;
                <b>{status.status}</b>
              </label>
            ))}</div>
            <div className="mr-5 mb-2">
              <img title="Archive"
               style={{ cursor: selectTaskId.length > 0 && !archiveFlag ? 'pointer' : 'not-allowed', opacity: selectTaskId.length > 0 && !archiveFlag ? 1 : 0.5 }}
                onClick={selectTaskId.length > 0 && !archiveFlag ? updateArchivedTasks : ''} 
                src={PCArchiveIcon} />
             </div></div> 
            </>)
            }
          </Col>
          {uiCompentents===true?  // for All Tasks Tab
         ( <AllUsersTaskData
          store={props.store} setStore={props.setStore}
          setloading={props.setloading}
          handleAllUserTask={handleAllUserTask}
          setAgencyMemberList={props.setAgencyMemberList}
          agencyMemberList={props.agencyMemberList}
          alltasksToDisplay={alltasksToDisplay}
          userData={props.userData}
          LoggedUserRole={LoggedUserRole}
          loggedUserId={props.loggedUserId}
            teamMemberList={props.teamMemberList}
            statusList={props.taskStatus}
            taskList={props.taskList}
            taskName={taskName}
            setTeamMemberList={props.setTeamMemberList}
            viewTaskData={taskData}
            setAllUsersTasks={setAllUsersTasks}
          viewTaskPopup={viewTaskPopup}
          setViewTaskPopup={setViewTaskPopup}
            handleCloseCreateTaskPopup={handleCloseCreateTaskPopup}
          handleSubmitHistory={handleSubmitHistory}
          />):archivedUiCompentents===true?(<ArchivedTaskData     // for Archived Tasks Tab
            // setloading={props.setloading}
            // handleArchivedTask={handleArchivedTask}
            store={props.store} setStore={props.setStore}
            setAgencyMemberList={props.setAgencyMemberList}
            agencyMemberList={props.agencyMemberList}
            archivedtasksToDisplay={archivedtasksToDisplay}
            userData={props.userData}
            loggedUserId={props.loggedUserId}
              teamMemberList={props.teamMemberList}
              statusList={props.taskStatus}
              taskList={props.taskList}
              taskName={taskName}
              setTeamMemberList={props.setTeamMemberList}
              viewTaskData={taskData}
              setAllUsersTasks={setAllUsersTasks}
            viewTaskPopup={viewTaskPopup}
            setViewTaskPopup={setViewTaskPopup}
              handleCloseCreateTaskPopup={handleCloseCreateTaskPopup}
            handleSubmitHistory={handleSubmitHistory}
            />):
          (<MyTaskDataUi                    // for My Tasks Tab 
          
          store={props.store} setStore={props.setStore}
          setAgencyMemberList={props.setAgencyMemberList}
          agencyMemberList={props.agencyMemberList}
          setViewTaskPopup={setViewTaskPopup}
          viewTaskPopup={viewTaskPopup}
          assignedLoading={assignedLoading}
          setAssingedLoading={setAssingedLoading}
          tasksToDisplay={tasksToDisplay}
          userData={props.userData}
          loggedUserId={props.loggedUserId}
            teamMemberList={props.teamMemberList}
            statusList={props.taskStatus}
            taskList={props.taskList}
          LoggedUserRole={props.LoggedUserRole}
            setAllUsersTasks={setAllUsersTasks}
            taskName={taskName}
            viewTaskData={taskData}
            setSelectTaskId={setSelectTaskId}
            statusFilter={statusFilter}
            selectTaskId={selectTaskId}
            handleCloseCreateTaskPopup={handleCloseCreateTaskPopup}
          handleSubmitHistory={handleSubmitHistory}/>
        )}
        </Row>
        </Row>
      </Card>
    </>
  )
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,

  };
};

export default connect(mapStateToProps)(SWTeamTask);